import { Compass, BarChart3, RefreshCw, Lightbulb } from 'lucide-react'

const ICONS = { decouverte: Compass, bilan_annuel: BarChart3, suivi: RefreshCw, recommandation: Lightbulb }
const LABELS = {
  decouverte:     { title: 'Découverte',     desc: "Premier rendez-vous · KYC complet, objectifs, profil de risque" },
  bilan_annuel:   { title: 'Bilan annuel',   desc: "Revue annuelle · réévaluation patrimoine + ajustements" },
  suivi:          { title: 'Suivi',          desc: "Suivi d'un plan en cours · pas de KYC complet" },
  recommandation: { title: 'Recommandation', desc: "Décision ciblée sur un produit ou un dispositif" },
}

export default function KindCard({ kind, selected, onClick }) {
  const Icon = ICONS[kind]
  const meta = LABELS[kind]
  const ring = selected ? 'border-ink shadow-[0_0_0_2px_#0d0d0d_inset]' : 'border-line hover:border-terra-500'
  return (
    <button
      type="button"
      onClick={() => onClick(kind)}
      className={`flex items-start gap-3.5 rounded-xl border bg-white p-5 text-left transition-colors ${ring}`}
    >
      <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-[10px] ${selected ? 'bg-ink text-terra-500' : 'bg-line/60 text-fiscal-fg'}`}>
        <Icon size={20} strokeWidth={1.6} />
      </div>
      <div>
        <div className="text-[14px] font-semibold">{meta.title}</div>
        <div className="text-[12px] leading-snug text-muted">{meta.desc}</div>
      </div>
    </button>
  )
}
